<script setup lang="ts">
import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

const gameStore = useGameStore();
</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="gameStore.player!.profileImage"
    :toast-text="t('news.types.spyTechStolen.title')"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="gameStore.player!.profileImage"
      :header="t('news.types.spyTechStolen.title')"
    >
      <div>
        {{ t('news.types.spyTechStolen.body') }}
        <div class="pt-2">
          {{ t('news.types.spyTechStolen.scienceLost', { points: props.newsItem.contentData.science_stolen }) }}
        </div>
      </div>
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>